import React from 'react';
import { ILegalTransactionRelationship } from '../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationship';
import { DocumentOverview } from '../../Document/DocumentOverview';
import { LandRegisterQueryTable } from './LandRegisterQueryTable';
import { IRealEstate } from '../../Interfaces/IRealEstate';
import { ILegalTransactionFullObject } from '../../Interfaces/ILegalTransaction';
import { IDocumentDirectoryHasDocument } from '../../Interfaces/IDocumentDirectoryHasDocument';
import { IDocumentDirectory } from '../../Interfaces/IDocumentDirectory';
import { ILegalPhaseFullObject } from '../../Interfaces/ILegalPhase';
import { ILegalRequirementState } from '../../Interfaces/ILegalRequirementState';

interface IProps {
  legalTransaction: ILegalTransactionFullObject;
  relationship: ILegalTransactionRelationship;
  setRelationship: Function;
  documentArray: IDocumentDirectoryHasDocument[];
  documentDirectoryArray: IDocumentDirectory[];
  setDocumentArray: Function;
  setDocumentDirectoryArray: Function;

  legalPhaseFullObjectArray: ILegalPhaseFullObject[];
  setLegalPhaseFullObjectArray: Function;
  legalReqStates: ILegalRequirementState[];
}

export const LandRegisterMain: React.FC<IProps> = ({
  legalTransaction,
  relationship,
  setRelationship,
  documentArray,
  documentDirectoryArray,
  setDocumentArray,
  setDocumentDirectoryArray,
  legalPhaseFullObjectArray,
  setLegalPhaseFullObjectArray,
  legalReqStates,
}) => {
  return (
    <>
      <LandRegisterQueryTable
        legalTransaction={legalTransaction}
        relationship={relationship}
        realEstateArray={relationship.RealEstateArray}
        setRealEstateArray={(newRealEstateArray: IRealEstate) =>
          setRelationship({
            ...relationship,
            RealEstateArray: newRealEstateArray,
          })
        }
        documentArray={documentArray}
        documentDirectoryArray={documentDirectoryArray}
        setDocumentArray={setDocumentArray}
        setDocumentDirectoryArray={setDocumentDirectoryArray}
        legalPhaseFullObjectArray={legalPhaseFullObjectArray}
        setLegalPhaseFullObjectArray={setLegalPhaseFullObjectArray}
        legalReqStates={legalReqStates}
      />

      <DocumentOverview
        allowRemove
        allowUpload
        documentArray={relationship.DocumentArray}
        setDocumentArray={newDocuments =>
          setRelationship({
            ...relationship,
            DocumentArray: newDocuments.map(d => ({
              ...d,
              DocumentPurpose: 'Dokument Grundbuchauszug',
            })),
          })
        }
        title='Bereitgestellte Daten'
        titleVariant='h6'
        marginTop={5}
      />
    </>
  );
};
